import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "../header/header";
import HeaderImageSection from "../shared/headerImageSection";
import FooterComponent from "../footerComponent/footerComponent";
import { API_URL } from "../../variables";
import axios from "axios";
//import "./CommitteeContributions.scss";

const CommitteeContributions = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    getCommitteeContributions();
  }, []);
  const getCommitteeContributions = async () => {
    let res = await axios.get(API_URL + "committee_results");
    if (res?.data?.body.length > 0) {
      setData(res?.data?.body);
    }
  };
  return (
    <>
      <Header />
      <HeaderImageSection />
      <section className="desktopView p-4 container bg-white mt-4">
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead className="tableHeader">
              <TableRow>
                <TableCell className="text-white">Committee Member</TableCell>
                <TableCell className="text-white text-center">
                  Number of Contributions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="tableBody">
              {data?.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>
                      <p className="font-bold mb-0 text-capitalize">
                        {item?.name?.split(",")[0]}
                      </p>
                      <p className="mb-0">{item?.name?.split(",")[1]}</p>
                    </TableCell>
                    <TableCell>
                      <p className="text-center mb-0">{item.count}</p>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </section>
      <section className="phoneView p-4 container bg-white mt-4">
        <TableContainer>
          <Table aria-label="simple table">
            <TableHead className="tableHeader">
              <TableRow>
                <TableCell className="text-white">
                  Committee Member Contributions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="tableBody">
              {data?.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>
                      <p className="font-bold mb-0 text-capitalize">
                        {item?.name?.split(",")[0]}
                      </p>
                      <p className="mb-0">Phone No : {item?.name?.split(",")[1]}</p>
                      <p className="mb-0 font-bold">
                        Contributions : {item.count}
                      </p>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </section>
      <FooterComponent />
    </>
  );
};
export default CommitteeContributions;
